import React, {useEffect, useState} from "react";
import common from "../../translations/it/common.json";
import style from "./ElencoAssistentiFamiliari.module.css"
import Button from "../../components/Button/Button";
import Table from "../../components/table/Table";
import RicercaAssistentiAF from "./RicercaAssistentiAF/RicercaAssistentiAF";
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {setSearch} from "../../actions/IndexActions";
import AnagraficaService from "../../services/AnagraficaService";
import Spinner from "../../components/spinner/Spinner";
import Pagination from "../../components/pagination/Pagination";
import Utils from "../../utils/Utils";
import AssistentiService from "../../services/AssistentiService";

function ElencoAssistentiFamiliari(props) {

    const [flagInserisciAssistente, setFlagInserisciAssistente] = useState(false)
    const [showSpinner, setShowSpinner] = useState(false)
    const [pagination, setPagination] = useState({size: 5, page: 0, sort: "cognome", order: "asc", paginazione: true})
    const button = useSelector(state => state.searchReducer)
    const dispatch = useDispatch()
    const [rows, setRows] = useState([])
    const nazioniPerCodice = JSON.parse(sessionStorage.getItem("nazioniPerCodice"))
    const provincePerCodice = JSON.parse(sessionStorage.getItem("provincePerCodice"))
    const comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
    const siglaProvincePerCodice = JSON.parse(sessionStorage.getItem("siglaProvincePerCodice"))
    const sessioneUtente=JSON.parse(sessionStorage.getItem("sessioneUtente"))
    const history = useHistory()
    const ruolo = sessioneUtente?.ruolo?.toUpperCase()
    const cols = [
        {name: "Cognome", key: "cognome", typeSort: "ASC"},
        {name: "Nome", key: "nome", typeSort: "ASC"},
        {name: "Data di nascita", key: "dataNascita", typeSort: "ASC"},
        {name: "Comune di nascita", key: "comuneNascita", typeSort: "ASC"},
        {name: "Codice fiscale", key: "codiceFiscale", typeSort: "ASC"},
        {
            type: "button",
            key: "id",
            onClick: onClickButtonModifica,
            typeButton: "White",
            text: "Modifica profilo",
            className: style.buttonTable
        }

    ]

    useEffect(() => {
        getAllCandidati()
    }, [pagination.page, pagination.sort, pagination.order])

    function getAllCandidati() {
        setShowSpinner(true)
        AnagraficaService.getAllCandidati(pagination).then(res => {
            let newPagination = {...pagination}
            res.data.content.forEach(element => {
                element.nome = element.nome.toUpperCase()
                element.cognome = element.cognome.toUpperCase()
                element.codiceFiscale = element.codiceFiscale.toUpperCase()
                element.comuneNascita = comuniPerCodice[element.comuneNascita] ? comuniPerCodice[element.comuneNascita].descrizione : nazioniPerCodice[element.comuneNascita]?nazioniPerCodice[element.comuneNascita].descrizione:""
                element.dataNascita = Utils.transformDateForFrontend(element.dataNascita)
            })
            newPagination.totalPages = res.data.totalPages
            newPagination.totalElements = res.data.totalElements
            setRows(res.data.content)
            setPagination(newPagination)
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation GET Candidati: " + reason)
            setRows([])
            setShowSpinner(false)
        })
    }

    function changePage(newPage) {
        let newPagination = {...pagination}
        newPagination.page = newPage
        setPagination(newPagination)
    }

    function setPaginationSort(sort, order) {
        let newPagination = {...pagination}
        newPagination.sort = sort
        newPagination.order = order
        setPagination(newPagination)
    }


    function onClickInserisciAssistente() {
        if (button && button.buttonFlag) dispatch(setSearch(false))
        else {
            if (flagInserisciAssistente) setFlagInserisciAssistente(false)
            else setFlagInserisciAssistente(true)
        }
    }

    function onClickButtonModifica(idCandidato) {
        Utils.recuperaDatiAssistente(idCandidato, dispatch, history, "/wizardRegistro", comuniPerCodice, siglaProvincePerCodice, nazioniPerCodice, provincePerCodice)
    }

    function onClickAnteprima() {
        setShowSpinner(true)
        AssistentiService.getExportFile({formato: "pdf"}).then(res => {
            Utils.visualizzaPdf(res.data.stream, res.data.descrizione, res.data.formato)
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation GET Export File: " + reason)
            setShowSpinner(false)
        })
    }

    function onClickSalvaCsv() {
        setShowSpinner(true)
        AssistentiService.getExportFile({formato: "csv"}).then(res => {
            Utils.downloadReport(res.data.stream, res.data.descrizione, res.data.formato)
            setShowSpinner(false)
        }).catch(reason => {
            console.log("Errore Operation GET Export File: " + reason)
            setShowSpinner(false)
        })
    }

    const iconButton = (
        <div style={{marginRight: "10px"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor"
                 className="bi bi-arrow-up" viewBox="0 0 16 16">
                <path fillRule="evenodd"
                      d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"/>
            </svg>
        </div>
    )

    return (
        <div className={"pt-4"}>
            <Spinner show={showSpinner}/>
            <div className={"row"} style={{margin: "0", width: "100%"}}>
                <div className={ruolo !== "RAF-RDSS" ? "col-7" : "col-8"} style={{minWidth: "fit-content"}}>
                    <div>
                        <h5 style={{fontWeight: "bold"}}>{common.Registro.titolo}</h5>
                    </div>
                    {!(button && button.buttonFlag) && !flagInserisciAssistente ?
                        <div>
                            <p>{common.Registro.sottotitolo}</p>
                        </div> : <></>}

                </div>
                <div className="col-3" style={{
                    minWidth: "fit-content",
                    minHeight: "80px"
                }}>
                    <Button
                        id={(button && button.buttonFlag) || flagInserisciAssistente ? "Annulla" : "InserisciAssistente"}
                        onClick={onClickInserisciAssistente}
                        typeButton={"Blue"}
                        disabled={ruolo !== "RAF-RDS" && ruolo !== "RAF-ADMIN" && !((button && button.buttonFlag) || flagInserisciAssistente)}
                        style={{height: "60px", width: "300px",display:ruolo !== "RAF-RDS" && ruolo !== "RAF-ADMIN" && !((button && button.buttonFlag) || flagInserisciAssistente) ?"none":""}}
                        text={(button && button.buttonFlag) || flagInserisciAssistente ? "Annulla" : common.Registro.buttonInserisci}
                        icon={(button && button.buttonFlag) || flagInserisciAssistente ? iconButton : ""}
                    />
                </div>
            </div>

            {(button && button.buttonFlag) || flagInserisciAssistente ?
                <div>
                    <RicercaAssistentiAF flagRicercaOInserisci={button && button.buttonFlag ? "RICERCA" : "INSERISCI"}/>
                </div> : <></>
            }

            <div style={{marginTop: "50px"}}
                 className={(button && button.buttonFlag) || flagInserisciAssistente ? style.backgroundMode : ""}>
                <Table
                    cols={ruolo !== "RAF-RDS" && ruolo !== "RAF-ADMIN" ? cols.slice(0,4) : cols}
                    rows={rows}
                    id={"tabellaAssistentiFamiliari"}
                    title={"Elenco Assistenti Familiari"}
                    allegati={true}
                    setSort={setPaginationSort}
                    onClickAnteprima={onClickAnteprima}
                    onClickSalvaCsv={onClickSalvaCsv}
                />
                {rows && rows.length > 0 ? <Pagination pagination={pagination} changePage={changePage}/> : <></>}
            </div>

        </div>
    );

}

export default ElencoAssistentiFamiliari;
